import { cn } from '@/lib/utils';
import React, { ReactNode } from 'react';

interface CardTitleProps {
  icon?: ReactNode;
  text: string | ReactNode;
  className?: string;
}

export default function CardTitle({ icon, text, className }: CardTitleProps) {
  return (
    <div className={cn('flex gap-1.5 items-center w-full', className)}>
      <div>{icon && icon}</div>
      <div className="w-full">{text}</div>
    </div>
  );
}
